export const emailValidator = (email = '') => {
  const validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
  if (email?.match(validRegex)?.[0]?.length == email.length) {
    return true;
  } else return false;
};
